export default {
  SkipToContent__TEXT: "Skip to content",
};
